// 顧客接点出力形式

export const LEAF_TYPES = {
  item: 'item',
  itemCategory: 'itemCategory',
  store: 'store',
  ymd: 'ymd',
  day: 'day',
  time: 'time',
  priceLine: 'priceLine',
  posNumber: 'posNumber',
}

export const LEAF_TYPE_LABELS = {
  [LEAF_TYPES.item]: '単品',
  [LEAF_TYPES.itemCategory]: '分類',
  [LEAF_TYPES.store]: '店舗',
  [LEAF_TYPES.ymd]: '年月日',
  [LEAF_TYPES.day]: '曜日',
  [LEAF_TYPES.time]: '時間帯',
  [LEAF_TYPES.priceLine]: 'プライスライン',
  [LEAF_TYPES.posNumber]: 'レジ番号',
}

export const LEAF_TYPES_ORDERED = [
  LEAF_TYPES.item,
  LEAF_TYPES.itemCategory,
  LEAF_TYPES.store,
  LEAF_TYPES.ymd,
  LEAF_TYPES.day,
  LEAF_TYPES.time,
  LEAF_TYPES.priceLine,
  LEAF_TYPES.posNumber,
].map(id => ({ id, label: LEAF_TYPE_LABELS[id] }))

// 業務別追加表示項目

export const ADDITIONAL_COLUMNS = {
  itemSelection: 'itemSelection',
  adoption: 'adoption',
  planogram: 'planogram',
  promotion: 'promotion',
  itemDistribution: 'itemDistribution',
  spaceDistribution: 'spaceDistribution',
  others: 'others',
}

export const ADDITIONAL_COLUMN_LABELS = {
  [ADDITIONAL_COLUMNS.itemSelection]: '品揃え',
  [ADDITIONAL_COLUMNS.adoption]: '採用/不採用',
  [ADDITIONAL_COLUMNS.planogram]: '棚割',
  [ADDITIONAL_COLUMNS.promotion]: 'ターゲット販促',
  [ADDITIONAL_COLUMNS.itemDistribution]: '販促単品分配',
  [ADDITIONAL_COLUMNS.spaceDistribution]: '理論スペース分配',
  [ADDITIONAL_COLUMNS.others]: 'その他顧客接点情報',
}

export const ADDITIONAL_COLUMNS_ORDERED = [
  ADDITIONAL_COLUMNS.itemSelection,
  ADDITIONAL_COLUMNS.adoption,
  ADDITIONAL_COLUMNS.planogram,
  ADDITIONAL_COLUMNS.promotion,
  ADDITIONAL_COLUMNS.itemDistribution,
  ADDITIONAL_COLUMNS.spaceDistribution,
  ADDITIONAL_COLUMNS.others,
].map(id => ({ id, label: ADDITIONAL_COLUMN_LABELS[id] }))

// 採用順算出ベース

export const ADOPT_ORDER = {
  customerCount: 'customer_count',
  usedRateWeightedAverage: 'used_rate_weighted_average',
  storeAmount: 'store_amount',
}

export const ADOPT_ORDER_LABELS = {
  [ADOPT_ORDER.customerCount]: 'ID数',
  [ADOPT_ORDER.usedRateWeightedAverage]: '加重平均利用者率',
  [ADOPT_ORDER.storeAmount]: '店舗利用金額',
}

export const ADOPT_ORDER_ORDERED = [
  ADOPT_ORDER.customerCount,
  ADOPT_ORDER.usedRateWeightedAverage,
  ADOPT_ORDER.storeAmount,
].map(id => ({ id, label: ADOPT_ORDER_LABELS[id] }))
